import { AuditService } from '@core/services/audit.service';

export function registerGlobalJsErrors(audit: AuditService) {
  window.onerror = (message, source, lineno, colno) => {
    audit.logError({
      applicationName: 'LRP Proveedores Frontend',
      exception: `${message} at ${source}:${lineno}:${colno}`,
      frontendRoute: location?.pathname || '',
      userAgent: navigator?.userAgent || '',
      browser: 'Unknown',
    });
    return true;
  };

  window.addEventListener('unhandledrejection', (event) => {
    audit.logError({
      applicationName: 'LRP Proveedores Frontend',
      exception: event.reason?.message || 'Unhandled Promise Rejection',
      frontendRoute: location?.pathname || '',
      userAgent: navigator?.userAgent || '',
      browser: 'Unknown',
    });
  });
}
